import { render, staticRenderFns } from "./followIndex.vue?vue&type=template&id=2d1122f7&scoped=true"
import script from "./followIndex.vue?vue&type=script&lang=js"
export * from "./followIndex.vue?vue&type=script&lang=js"
import style0 from "./followIndex.vue?vue&type=style&index=0&id=2d1122f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1122f7",
  null
  
)

export default component.exports